import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isValidBSN(bsn: number): boolean {
  const bsnString = bsn.toString();

  // Must be exactly 9 digits and not start with 0
  if (bsnString.length !== 9 || bsnString[0] === '0') {
    return false;
  }

  const digits = bsnString.split('').map(Number);
  const sum =
    digits[0] * 9 +
    digits[1] * 8 +
    digits[2] * 7 +
    digits[3] * 6 +
    digits[4] * 5 +
    digits[5] * 4 +
    digits[6] * 3 +
    digits[7] * 2 -
    digits[8];

  const isValid = sum % 11 === 0;

  return isValid;
}

export function bsnValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value && !isValidBSN(Number(control.value)) ? { bsn: true } : null;
  };
}
